
// This file defines the steps for the onboarding modal. The steps are determined based on the values of hasCoach and hasAssessment.
export type StepType = "A" | "B" | "C" | "D1" | "D2" | "E";

export function getSteps(hasAssessment: boolean, hasCoach: boolean): StepType[] {
  const steps: StepType[] = [];

  if (hasAssessment) steps.push("A"); 
  if (hasCoach) steps.push("B");

  steps.push("C");

//   D1 is shown when assessmnet is true
  if (hasAssessment) {
    steps.push("D1");
  } else {
    steps.push("D2");
  }

  steps.push("E");

  return steps;
}